import type {FCWithChildren} from 'types';
import {Card} from 'components/card';

export const DefaultContainer: FCWithChildren = ({children}) => (
  <Card color={'primary'}>
    <Card.Content>{children}</Card.Content>
  </Card>
);
